<template>
    <div>
        <refresh :on-refresh="refresh" :refreshing="refreshing"></refresh>
        <loading :loading="loading"></loading>
        <div v-if="message" class="show-message">
            <div v-if="playing">
                <div class="row message-icons">

                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-xs-12 col-sm-10 col-md-8 col-lg-6 video-container">
                        <div class="video-content">
                            <video autoplay controls class="video-player">
                                <source :src="message.message.path" :type="message.message.mime" >
                            </video>
                        </div>
                    </div>
                    <div class="col-12 close-btn u-mt1">
                        <ion-button shape="round" v-on:click="hideCall()" color="medium" style="color : var(--ion-color-dark);">
                            <i class="fas fa-times"></i> &nbsp; Close
                        </ion-button>
                    </div>
                </div>
            </div>
            <div v-else>
                <ion-avatar class="big-avatar">
                    <img :src="message.message.user.avatar" v-if="message.message.user.avatar" v-on:click="viewUser(message.message.user.id)">
                    <img src="../../assets/ghost-avatar-white.png" class="dark-img" v-else>
                </ion-avatar>
                <div class="message-details">
                    Video call from {{message.message.user.name}}
                    is waiting
                </div>
                <div class="row message-icons">
                    <audio autoplay loop>
                        <source src="../../assets/phone-loop.mp3" type="audio/mp3">
                    </audio>
                    <div class="col-6" v-on:click="hideCall()">
                        <ion-icon name="close-circle" color="danger"></ion-icon>
                    </div>
                    <div class="col-6" v-on:click="playCall()">
                        <ion-icon name="play-circle" color="success"></ion-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" >
                <Logo logo-type="video" />
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" v-if="noMessages">
                You do not have any calls.
            </div>
            <div class="col-11 col-xs-11 col-md-6" v-else>
                <div v-for="message in messages" v-bind:key="message.id" class="u-mt1 u-mb1">
                    <div class="call-container" :class="message.viewed_at ? '-viewed' : '-new'" v-on:click="showCall(message)">
                        <div class="call-avatar-container">
                            <ion-avatar class="call-avatar">
                                <img :src="message.message.user.avatar" v-if="message.message.user.avatar">
                                <img src="../../assets/ghost-avatar-white-thumb.png" class="dark-img" v-else>
                            </ion-avatar>
                        </div>
                        <div class="call-info">
                            <div class="call-title">
                                {{message.message.title}}
                            </div>
                            <div class="call-date">
                                {{dateFormat(message.message.send_at, 'Do MMMM YYYY')}}
                            </div>
                        </div>
                        <div class="call-meta">
                            <div v-if="!message.viewed_at" class="call-new"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ion-infinite-scroll @ionInfinite="loadMore" threshold="100px" position="bottom">
            <ion-infinite-scroll-content loading-spinner="dots"></ion-infinite-scroll-content>
        </ion-infinite-scroll>
       <return-home v-if="complete || noMessages"></return-home>
    </div>
</template>

<script>
import {auth} from '../../mixins/auth';
import {userdetails} from '../../mixins/userdetails';
import {formatting} from '../../mixins/formatting';
import ReturnHome from '@/components/ReturnHome.vue';
import Refresh from '@/components/Refresh.vue';
import Loading from '@/components/Loading.vue';
import Logo from '@/components/Logo.vue';
import _ from 'lodash';

export default {
    name : 'Calls',
    mounted : function () {
        this.getMessages();
        // this.showNotificationMessage();
    },
    mixins : [auth, userdetails, formatting],
    components : {
        ReturnHome, Logo, Refresh, Loading
    },
    data : function () {
        return {
            messages : [],
            page     : 1,
            complete : false,
            loading  : false,
            refreshing : false,
            message    : null,
            playing    : false
        }
    },
    computed : {
        noMessages : function () {
            return _.size(this.messages) == 0;
        }
    },
    methods : {
        refresh : function () {
            this.refreshing = true;
            this.page = 1;
            this.getMessages();
        },
        hideLoading : function () {
            this.loading = false;
            this.refreshing = false;
        },
        loadMore : function (event) {
            // console.log('loading messages', event);
            this.getMessages();
            event.target.complete();
        },
        getMessages : function () {
            let self = this;
            if (this.complete) {
                this.hideLoading();
                return;
            }
            this.loading = true;
            this.axios.get(this.api + 'messages/inbox/video?page=' + this.page)
                .then(response => {
                    if (self.refreshing) {
                        self.messages = [];
                        self.refreshing = false;
                    }

                    var messages = _.reverse(_.sortBy(response.data, ['send_at']));
                    self.hideLoading();
                    if (_.size(messages) > 0) {
                        _.each(messages, function (message) {
                            self.messages.push(message);
                        });
                        self.page = self.page + 1;
                    } else {
                        self.complete = true;
                    }
                })
                .catch(error => {
                    console.error('Error getting messages', error);
                    self.hideLoading();
                });
        },
        showNotificationMessage : function () {
            let self = this;
            if (localStorage.getItem('ghost.pushmessage')) {
                let notification = JSON.parse(localStorage.getItem('ghost.pushmessage'));
                if (notification.type && notification.type == 'video') {
                // load that message via the api
                this.axios.get(this.api + 'messages/' + notification.id + '/view')
                    .then(response => {
                        // open it if it exists
                        self.showCall(response.data);
                        // clear the root notification
                        localStorage.removeItem('ghost.pushmessage');
                    })
                    .catch(error => {
                        localStorage.removeItem('ghost.pushmessage');
                    });
                }
            }
        },
        // viewed : function (isVisible, entry, message) {
        //     if (isVisible && !message.viewed_at) {
        //         this.axios.post(this.api + 'messages/' + message.message_id + '/viewed')
        //             .then(response => {
        //                 message.viewed_at = true;
        //                 // console.log(response.data);
        //             })
        //             .catch(error => {
        //                 // console.error('Error setting message as viewed', error);
        //             })
        //     }
        // },
        viewUser : function (id) {
            this.$router.push({name : 'user', params : {id : id}});
        },
        back : function () {
            this.$router.push({name : 'home'});
        },
        messageViewed : function () {
            let self = this;
            if (!this.message) {
                console.debug('no message to view');
                return;
            }
            this.axios.post(this.api + 'messages/' + this.message.message_id + '/viewed')  // eslint-disable-next-line
                .then(response => {
                    self.message.viewed_at = true;
                })
                .catch(error => {
                    console.error('Error setting message as viewed', error);
                })
        },
        playCall : function () {
            this.playing = true;
            this.messageViewed();
        },
        hideCall : function () {
            this.message = null;
            this.playing = false;
        },
        showCall : function (message) {
            this.$root.closeMenu();
            this.message = message;
        }
    }
}
</script>

<style>
.call-container.-viewed {
    background-color : #6596af;
}
.show-message {
    position: fixed;
    top: -50px;
    left: 0;
    width: 100%;
    height: calc(100vh + 50px);
    background: var(--ion-color-dark);
    color: var(--ion-color-dark-contrast);
    z-index: 20000;
    padding : 5rem 1rem;
}
.message-details {
    padding : 2rem;
    font-weight : 900;
    font-size: 30px;
    line-height: 42px;
}
.message-icons {
    font-weight : 900;
    font-size: 30px;
    line-height: 38px;
}
.message-icons ion-icon {
    width : 96px;
    height : 96px;
    background: white;
    padding: 0;
    border-radius: 48px;
    margin: 0;
}
.message-icons ion-icon.ion-color-success.hydrated {
    animation: bigpulse 3s infinite;
}
.message-icons audio {
    width : 90%;
    margin : 10px auto;
}
</style>